(function () {
  // MyStoreFundingの支援ページだけで動かす
  if (!location.pathname.startsWith('/apps/mimigoto/support/')) return;

  const parseYen = (text) => {
    if (!text) return NaN;
    // "¥1", "￥1,000", "1円" などから数字だけ抜く
    const digits = String(text).replace(/[^\d]/g, '');
    return digits ? Number(digits) : NaN;
  };

  const apply = () => {
    // ① 文言置換
    const totalLabel = document.querySelector('.msf_current_price_title');
    if (totalLabel) totalLabel.textContent = '現在の総額';

    const supporterLabel = document.querySelector('.msf_supporter_title');
    if (supporterLabel) supporterLabel.textContent = 'パートナー';

    // ② 目標金額：1円 or 空/不明なら非表示、2円以上なら表示
    const goalBox = document.querySelector('.msf_container_target');
    const goalValueEl = document.querySelector('.msf_target_value');

    if (goalBox && goalValueEl) {
      const yen = parseYen(goalValueEl.textContent);

      // 空白/取得失敗/0/1 は非表示、2以上は表示
      if (!Number.isFinite(yen) || yen <= 1) {
        goalBox.style.display = 'none';
      } else {
        goalBox.style.display = '';
      }
    }
  };

  // すぐ実行 + 遅延描画対策で数回実行
  apply();
  setTimeout(apply, 300);
  setTimeout(apply, 1200);
})();